module.exports = __webpack_public_path__ + "img/jdjs.645530f7.png";